import Fetch from 'Util/fetcher';
import { errorLogger } from '@ajaibid/utils';
import { DEFAULT_POST_RESPONSE } from '@config/constanta';
import { stockAutoOrderUrl, stockAutoOrderByIdUrl } from '../_endpoint';
import { mtPostOrderUrl } from './_endpoint';

const fetchPost = (resourceUrl, payload) =>
  Fetch.post(resourceUrl, payload)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_POST_RESPONSE, err_message: error.message };
    });

const fetchPut = (resourceUrl, payload) =>
  Fetch.put(resourceUrl, payload)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_POST_RESPONSE, err_message: error.message };
    });

// MT Limit order
export const postMtBuy = (payload = {}) => fetchPost(mtPostOrderUrl('buy'), payload);
export const postMtSell = (payload = {}) => fetchPost(mtPostOrderUrl('sell'), payload);
export const postMtAmend = (payload = {}) => fetchPost(mtPostOrderUrl('amend'), payload);
export const postMtWithdraw = (payload = {}) => fetchPost(mtPostOrderUrl('withdraw'), payload);

// MT Auto order
export const postMtAutoOrder = (payload = {}) => fetchPost(stockAutoOrderUrl('MARGIN'), payload);
export const putMtAutoOrderAmend = (order_id, payload = {}) =>
  fetchPut(stockAutoOrderByIdUrl('', order_id), payload);
export const putMtAutoOrderDeactivate = (order_id, payload = {}) =>
  fetchPut(stockAutoOrderByIdUrl('pause/', order_id), payload);
export const putMtAutoOrderReactivate = (order_id, payload = {}) =>
  fetchPut(stockAutoOrderByIdUrl('resume/', order_id), payload);
export const putMtAutoOrderCancel = (order_id, payload = {}) =>
  fetchPut(stockAutoOrderByIdUrl('cancel/', order_id), payload);
